import { api } from "@/api";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { Barrio } from "@/shared/types/barrio";
import { sleep } from "@/shared/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";

export async function deleteBarrio(id:string) : Promise<Barrio> {
    await sleep(1000);
    const response = await api.delete("barrios/" + id);
    return response.data;
}

export function useDeleteBarrioMutation(id: string, mutationConfig: MutationConfig<Barrio> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: async () => await deleteBarrio(id),
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["barrios"] });
        },
    })
}

export interface DeleteBarrioMutationProps {
    id: string;
    mutationConfig?: MutationConfig<Barrio>;
    children?: (mutationResult: MutationResult<Barrio>) => ReactNode;
}

export function DeleteBarrioMutation({
    id,
    mutationConfig,
    children,
}: DeleteBarrioMutationProps) {
    const mutationResult = useDeleteBarrioMutation(id, mutationConfig);
    return children && children(mutationResult);
}

